import BaseAPIService from './base.service';

export default class ProjectAPIService extends BaseAPIService {
  apiBase: string | undefined;
  rootEndpoint: string;

  constructor(apiBase?: string) {
    super();
    this.rootEndpoint = '/api/projects';
    if (apiBase) this.apiBase = apiBase;
  }

  async getAll() {
    try {
      const res = await super.get({
        apiBase: this.apiBase,
        endpoint: `${this.rootEndpoint}`,
      });

      return res.json();
    } catch (err: any) {
      console.log('ProjectAPIService::getAll ', err);
      throw new Error(err.message);
    }
  }

  async getById(id: number) {
    try {
      const endpoint = `${this.rootEndpoint}/${id}`;
      const res = await super.get({ apiBase: this.apiBase, endpoint });

      return res.json();
    } catch (err: any) {
      console.log('ProjectAPIService::getById ', err);
      throw new Error(err.message);
    }
  }

  async getSignedUrl(id: number, fileName: string): Promise<{ signedUrl: string; fileName: string }> {
    try {
      const endpoint = `${this.rootEndpoint}/${id}/get-signed-url/?fileName=${fileName}`;
      const res = await super.get({ apiBase: this.apiBase, endpoint });

      return res.json();
    } catch (err: any) {
      console.log('ProjectAPIService::getSignedUrl ', err);
      throw new Error(err.message);
    }
  }

  async uploadBySignedUrl(url: string, file: File) {
    try {
      const res = await fetch(url, {
        method: 'PUT',
        body: file,
      });

      return res;
    } catch (err: any) {
      console.log('ProjectAPIService::uploadBySignedUrl ', err);
      throw new Error(err.message);
    }
  }

  async create(type: string) {
    try {
      const res = await super.post({
        apiBase: this.apiBase,
        endpoint: `${this.rootEndpoint}`,
        data: { type },
      });
      return res.json();
    } catch (err: any) {
      console.log('ProjectAPIService::create:: ', err);
      throw new Error(err.message);
    }
  }

  async update(project: Project) {
    try {
      const endpoint = `${this.rootEndpoint}/${project.id}/`;
      const res = await super.put({ apiBase: this.apiBase, endpoint, data: project });

      return res.json();
    } catch (err: any) {
      console.log('ProjectAPIService::create:: ', err);
      throw new Error(err.message);
    }
  }
}
